import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { useMerchantEmployee } from "Api/Queries/Merchants/Employees/useMerchantEmployee";
import { useParams } from "react-router";
import { Resources, useResource } from "Translations/Resources";
import { UpdateEmployeeDetailForm } from "Components/Merchant/Employees/UpdateEmployeeDetailForm";
import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";

const COMPONENT_RESOURCES = Resources.Employee.Detail;

export const EmployeeDetailPageContent = () => {
  const { publicID } = useParams();
  const { t } = useResource();
  const { data: currentMerchant, isLoading: isLoadingCurrentMerchant } =
    useGetMerchantQuery();

  const { data: employee, isLoading: isLoadingEmployee } = useMerchantEmployee(
    currentMerchant?.publicID,
    publicID,
  );

  if (isLoadingCurrentMerchant || isLoadingEmployee) {
    return <CenteredCircularProgress />;
  }

  if (!publicID) {
    return (
      <ErrorText>{t(COMPONENT_RESOURCES.NoEmployeeSelectedError)}</ErrorText>
    );
  }

  if (!employee || !currentMerchant) {
    return (
      <ErrorText>{t(COMPONENT_RESOURCES.EmployeeNotFoundError)}</ErrorText>
    );
  }

  return (
    <UpdateEmployeeDetailForm
      employee={employee}
      currentMerchant={currentMerchant}
    />
  );
};
